import UploadDocumentFormComponent from "../../../components/espace-document/UploadDocumentFormComponent";


export default function REUploadDocumentBloc() {

      return (
        <div className="">
          <div className="">
            <UploadDocumentFormComponent />
          </div>
        </div>
      )
}